/** Admin list UI — kartu compact di mobile, tabel di desktop */

export const adminTable = {
    card: 'bg-white rounded-xl shadow-zafu border border-zafu-cream-dark/60 overflow-hidden',
    desktopOnly: 'hidden',
    mobileOnly: '',
    list: 'flex flex-col gap-1.5',
    listItem:
        'bg-white rounded-xl border border-zafu-cream-dark/60 px-3 py-2 shadow-sm text-left',
    listItemClickable:
        'bg-white rounded-xl border border-zafu-cream-dark/60 px-3 py-2 shadow-sm cursor-pointer active:bg-zafu-cream/40 text-left',
    listTop: 'flex items-center justify-between gap-2 text-left',
    listTitle: 'font-semibold text-zafu-ink text-sm leading-tight truncate text-left',
    listSub: 'text-[11px] text-zafu-muted leading-tight truncate text-left',
    listMeta: 'mt-1 flex flex-wrap gap-1',
    listChip: 'inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-zafu-cream text-zafu-green',
    listChipMuted: 'inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-gray-100 text-zafu-muted',
    listChipOk: 'inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-green-100 text-green-700',
    listActions: 'flex items-center shrink-0',
    listEmpty: 'text-center text-zafu-muted text-sm py-8 px-3 bg-white rounded-xl border border-dashed border-zafu-cream-dark',
    scroll:
        'overflow-x-auto overscroll-x-contain [-webkit-overflow-scrolling:touch]',
    table: 'w-full min-w-[680px] text-sm border-collapse',
    thead: 'bg-zafu-green text-white',
    th: 'px-3 py-3 text-left text-xs font-semibold uppercase tracking-wide whitespace-nowrap',
    thSortable:
        'px-3 py-3 text-left text-xs font-semibold uppercase tracking-wide whitespace-nowrap cursor-pointer hover:bg-zafu-green-light transition-colors',
    thCenter:
        'px-3 py-3 text-center text-xs font-semibold uppercase tracking-wide whitespace-nowrap',
    tr: 'border-b border-zafu-cream-dark/70 hover:bg-zafu-cream/40 transition-colors',
    trClickable:
        'border-b border-zafu-cream-dark/70 hover:bg-zafu-cream/40 transition-colors cursor-pointer',
    td: 'px-3 py-3 text-sm text-zafu-ink whitespace-nowrap align-middle',
    tdMuted: 'px-3 py-3 text-sm text-zafu-muted whitespace-nowrap align-middle',
    tdCenter: 'px-3 py-3 text-sm text-zafu-ink text-center whitespace-nowrap align-middle',
    empty: 'px-4 py-12 text-center text-zafu-muted text-sm',
    searchToolbar: 'mb-3 flex flex-row items-center gap-2',
    searchWrap: 'relative flex-1 min-w-0',
    searchInput:
        'w-full pl-9 pr-3 py-2.5 border border-zafu-cream-dark rounded-xl text-base bg-white focus:ring-2 focus:ring-zafu-green/15 focus:border-zafu-green-soft h-[42px]',
    pageHeader: 'flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4',
    pageTitle: 'text-xl font-semibold text-zafu-ink flex items-center gap-2',
    pageSubtitle: 'text-sm text-zafu-muted mt-0.5',
    btnPrimary:
        'inline-flex items-center justify-center gap-1.5 px-4 py-2.5 bg-zafu-green text-white rounded-xl text-sm font-medium hover:bg-zafu-green-light transition-colors w-full sm:w-auto',
    actions: 'inline-flex items-center justify-center gap-1',
    actionBtn:
        'inline-flex items-center justify-center w-8 h-8 rounded-md text-sm transition-colors',
};

export const formatLokasiList = (names) => {
    if (!names?.length) return '-';
    return names.join(', ');
};
